import type { LoaderFunctionArgs } from "react-router";
import { Link, redirect } from "react-router";

import { PepettesLogo } from "#guidelines/PepettesLogo";
import { sessionStorage } from "#shared/Session.server";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const session = await sessionStorage.getSession(
    request.headers.get("cookie"),
  );

  const user = session.get("user");
  if (user) {
    throw redirect("/pepettes");
  }

  return null;
};

export default function Index() {
  return (
    <main className="bg-base-200 relative flex min-h-screen items-center justify-center">
      <div className="relative pt-8 pb-16">
        <div className="align flex flex-col items-center gap-8">
          <Link to="/login">
            <PepettesLogo />
          </Link>
        </div>
      </div>
    </main>
  );
}
